/**
 * The shared zer0paper haptic vocabulary (Design Constitution §5), typed.
 *
 * The canonical definition is the Constitution itself, not this file — the
 * durations below are copied from its web-fallback column so a Waves success
 * feels identical in the hand to a SendNaira or Kendi one. `public/waves.js`
 * carries the same table for the two non-bundled pages (operator console and
 * test client); if the Constitution changes, both follow it.
 */

export type Signature = 'tick' | 'press' | 'thump' | 'snag';

const PATTERN: Record<Signature, number[]> = {
  tick: [10], // selection, toggle, tab
  press: [15], // a primary action is committed
  thump: [40, 60, 40], // ⭐ real value delivered — reserved
  snag: [60, 40, 60], // error, blocked, declined
};

/**
 * Fire a haptic signature.
 *
 * Absent on desktop and iOS Safari, and a no-op when the OS has haptics off.
 * Both degrade to nothing here rather than substituting something louder,
 * because §5 says fall back to motion + sound, which the CSS already does.
 *
 * RESERVE THE THUMP. Waves declares exactly one moment worth it — the room
 * connecting. If everything thumps, nothing does.
 */
export function haptic(signature: Signature): void {
  try {
    navigator.vibrate?.(PATTERN[signature]);
  } catch {
    /* never let feedback break the flow it is confirming */
  }
}
